// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonCloseFullscreen_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.6427 0 11.201 3.44203 9 1.24073 9 7 14.7586 7 12.5584 4.7995 16 1.35747 14.6427 0ZM16 14.6427 12.558 11.201 14.7593 9H9V14.7586L11.2005 12.5584 14.6425 16 16 14.6427ZM4.79896 12.558 1.35732 16 0 14.6425 3.44164 11.2005 1.24139 9H7V14.7593L4.79896 12.558ZM0 1.35732 3.44203 4.79896 1.24073 7H7L7 1.24139 4.7995 3.44164 1.35747 0 0 1.35732Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.49701 10.4868 5.08276 7.90106.180054 2.99835 3.00848.169922 7.91119 5.07263 10.497 2.48682 10.497 10.4868 2.49701 10.4868ZM13.4969 2.49906 16.0826 5.08482 20.9853.182108 23.8138 3.01053 18.911 7.91325 21.4969 10.4991H13.4969V2.49906ZM18.9111 16.0846 21.4969 13.4989 13.4969 13.4989 13.4969 21.4989 16.0827 18.913 20.9854 23.8158 23.8138 20.9873 18.9111 16.0846ZM10.497 21.4976 7.91123 18.9118 3.00852 23.8145.180094 20.9861 5.0828 16.0834 2.49699 13.4976H10.497V21.4976Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonCloseFullscreen is a generated icon component.
 */
let IconCommonCloseFullscreen = IconCommonCloseFullscreen_1 = class IconCommonCloseFullscreen extends IconBaseElement {
    render() {
        return html `${IconCommonCloseFullscreen_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonCloseFullscreen.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonCloseFullscreen = IconCommonCloseFullscreen_1 = __decorate([
    customElement('zui-icon-common-close-fullscreen')
], IconCommonCloseFullscreen);
export { IconCommonCloseFullscreen };
